'use es6';

import { ActionTypes } from '../../constants/AppConstants';
export var applyTheme = function applyTheme(theme) {
  return {
    type: ActionTypes.APPLY_THEME,
    payload: {
      theme: theme
    }
  };
};